import React, { Component } from 'react';
import AdminSidebar from '../AdminSidebar/AdminSidebar';
import axios from 'axios';
import swal from 'sweetalert';
import BootstrapTable from 'react-bootstrap-table-next';
import LoadingOverlay from 'react-loading-overlay';
import DatePicker, { registerLocale } from 'react-datepicker';
import id from 'date-fns/locale/id';
import paginationFactory, {
  PaginationProvider,
} from 'react-bootstrap-table2-paginator';
import { Button, Modal, FormControl, FormLabel } from 'react-bootstrap';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { Link } from 'react-router-dom';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { API_URL } from '../../BaseUrlApi/Url';
import { RadioButton } from '../../CustomJS/RadioButton';
import moment from 'moment';
// import { RadioButton } from '../../CustomJS/RadioButton'
import 'moment/locale/id';
import './QueueManagement.css';
registerLocale('id', id);

const headers = {
  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
  'Content-Type': 'application/json',
};

const { SearchBar } = Search;

function dateFormatter(cell, row, rowIndex, formatExtraData) {
  return moment(cell).format('dddd, DD MMMM YYYY');
}

function queuesFormatter(cell, row, rowIndex, formatExtraData) {
  return (
    <div className="queues-buttons">
      <button
        onClick={() => {
          swal({
            title: 'Yakin Ingin Menghapus?',
            icon: 'warning',
            buttons: ['Batal', 'Hapus'],
            dangerMode: true,
          }).then((move) => {
            if (move) {
              let rowId = row.id;
              axios
                .delete(`${API_URL}/admin/queues/${rowId}`, { headers })
                .then((res) => {
                  window.location.href = '/queue-consult';
                });
            } else {
              return;
            }
          });
        }}
        style={{ margin: '.2em' }}
        className="btn btn-danger"
      >
        Hapus
      </button>
      <Link to={`detail-queue-online/${row.id}`}>
        <button className="btn btn-primary" style={{ margin: '.2em' }}>
          Detail
        </button>
      </Link>
    </div>
  );
}

function paymentFormatter(cell, row, rowIndex, formatExtraData) {
  if (row.payment_status === null) {
    return <button className="checkedin-style">n/a</button>;
  } else {
    if (row.payment_status.id === 1) {
      return <button className="checkedin-style">Belum Bayar</button>;
    } else if (row.payment_status.id === 2) {
      return <button className="done-style">Menunggu Konfirmasi</button>;
    } else if (row.payment_status.id === 3) {
      return <button className="process-style">Sudah Bayar</button>;
    } else if (row.payment_status.id === 4) {
      return <button className="emergency-style">Pembayaran Ditolak</button>;
    } else {
      return (
        <button className="emergency-style">Pembayaran Dikembalikan</button>
      );
    }
  }
}

function statusFormatter(cell, row, rowIndex, formatExtraData) {
  if (row.queue_status.id === 1) {
    return <button className="registered-style">Registered</button>;
  } else if (row.queue_status.id === 2) {
    return <button className="confirmed-style">Confirmed</button>;
  } else if (row.queue_status.id === 3) {
    return <button className="checkedin-style">Checked-in</button>;
  } else if (row.queue_status.id === 4) {
    return <button className="process-style">On-process</button>;
  } else if (row.queue_status.id === 5) {
    return <button className="done-style">Done</button>;
  } else if (row.queue_status.id === 6) {
    return <button className="passed-style">Passed</button>;
  } else if (row.queue_status.id === 7) {
    return <button className="confirmed-style">Canceled</button>;
  } else if (row.queue_status.id === 8) {
    return <button className="emergency-style">Emergency</button>;
  }
  return (
    <button className="registered-style">
      <p>{row?.queue_status?.name} </p>
    </button>
  );
}

function genderFormatter(cell, row, rowIndex, formatExtraData) {
  if (row.child !== null) {
    if (row.child.gender === 'female') {
      return <p>Perempuan</p>;
    } else {
      return <p>Laki-laki</p>;
    }
  } else {
    return <p style={{ color: 'red' }}>Data Anak Terhapus</p>;
  }
}

function shiftFormatter(cell, row) {
  if (cell !== undefined) {
    return cell;
  } else {
    return '-';
  }
}

let nameFilter;

class QueueConsultOnline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      childId: null,
      startDate: new Date(),
      // date: null,
      checkbox: false,
      radioValue: null,
      radioValues: null,
      date_queue: null,
      name_patient: '',
      showModal: false,
      data: null,
      page: 1,
      search: '',
      isSearched: false,
      products: [],
      columns: [
        {
          dataField: 'date',
          text: 'Tanggal',
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' },
          formatter: dateFormatter,
        },
        {
          dataField: 'shift.name',
          text: 'Shift',
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' },
          formatter: shiftFormatter,
        },
        {
          dataField: 'registration_number',
          text: 'No. Registrasi',
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' },
        },
        {
          dataField: 'child.fullname',
          text: 'Nama',
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' },
        },
        {
          dataField: 'child.age',
          text: 'Umur',
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' },
        },
        {
          dataField: 'queue_status.name',
          text: 'Status Antrian',
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' },
          formatter: statusFormatter,
        },
        {
          dataField: 'payment_status.name',
          text: 'Status Pembayaran',
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' },
          // filter: textFilter({
          //   getFilter: (filter) => {
          //     // nameFilter was assigned once the component has been mounted.
          //     nameFilter = filter;
          //   }
          // }),
          formatter: paymentFormatter,
        },
        {
          dataField: 'child.gender',
          text: 'Jenis Kelamin',
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' },
          formatter: genderFormatter,
        },
        {
          dataField: 'Aksi',
          text: 'Aksi',
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' },
          formatter: queuesFormatter,
        },
      ],
    };
  }

  async componentDidMount() {
    this.setState({ isLoaded: true });
    let getQueues = await axios.get(
      `${API_URL}/admin/queues?type=konsultasi_online&period=upcoming&page=1&limit=50`,
      {
        headers,
      }
    );
    this.setState({
      products: getQueues.data.queues.data,
      data: getQueues.data.queues,
      choice_queue: 'upcoming',
    });
    this.setState({ isLoaded: false });
  }

  getAllQueue = async (e) => {
    await this.setState({
      checkbox: !this.state.checkbox,
      isLoaded: true,
    });

    if (this.state.checkbox === true) {
      let getQueues = await axios.get(
        `${API_URL}/admin/queues?type=konsultasi_online&period=alltime&page=1&limit=50`,
        {
          headers,
        }
      );
      this.setState({
        products: getQueues.data.queues.data,
        data: getQueues.data.queues,
        page: 1,
        isSearched: false,
        radioValue: null,
        choice_queue: 'alltime',
      });
      this.setState({ isLoaded: false });
    } else {
      let getQueues = await axios.get(
        `${API_URL}/admin/queues?type=konsultasi_online&period=upcoming&page=1&limit=50`,
        {
          headers,
        }
      );
      this.setState({
        products: getQueues.data.queues.data,
        data: getQueues.data.queues,
        page: 1,
        radioValue: null,
        isSearched: false,
        choice_queue: 'upcoming',
      });
      this.setState({ isLoaded: false });
    }
  };

  handleFilter = (id) => {
    nameFilter(id);
  };

  resetQueue = async () => {
    try {
      this.setState({
        // products: getQueues.data.queues.data,
        // data: getQueues.data.queues,
        // page: 1,

        isLoaded: true,
        // isSearched: false,
      });
      let getQueues = await axios.get(
        `${API_URL}/admin/queues?type=konsultasi_online&period=upcoming&page=1&limit=50`,
        {
          headers,
        }
      );
      this.setState({
        products: getQueues.data.queues.data,
        data: getQueues.data.queues,
        page: 1,
        radioValue: null,
        radioValues: null,
        choice_queue: 'upcoming',
        checkbox: false,
        isLoaded: false,
        isSearched: false,
      });
    } catch (e) {
      console.log(e.response.data.message);
    }
  };

  searchQueue = async () => {
    // if (this.state.search.length > 0) {
    this.setState({
      showModal: false,
      isLoaded: true,
    });
    if (this.state.radioValues === 1) {
      let getQueues = await axios.get(
        `${API_URL}/admin/queues/search?type=konsultasi_online&period=${this.state.choice_queue}&keyword=${this.state.name_patient}`,
        { headers }
      );
      await this.setState({
        products: getQueues.data.queues,
        page: 1,
        // choice_queue: 'upcoming',
        radioValues: null,
        checkbox: false,
        // page_count: getParents.data.parents.length / 100,
        isLoaded: false,
        isSearched: true,
      });
    } else {
      let getQueues = await axios.get(
        `${API_URL}/admin/queues/search?type=konsultasi_online&period=${
          this.state.choice_queue
        }&keyword=${moment(this.state.date_queue).format('YYYY-MM-DD')}`,
        { headers }
      );
      await this.setState({
        products: getQueues.data.queues,
        page: 1,
        // choice_queue: 'upcoming',
        radioValues: null,
        checkbox: false,
        // page_count: getParents.data.parents.length / 100,
        isLoaded: false,
        isSearched: true,
      });
    }

    // } else {
    //   swal("Gagal!", "Masukkan minimal 3 karakter!", "error");
    // }
  };

  handleNextPage =
    ({ page, onPageChange }) =>
    async () => {
      await this.setState({
        page: this.state.page + 1,
        isLoaded: true,
      });
      if (this.state.radioValue === null) {
        let getQueues = await axios.get(
          `${API_URL}/admin/queues?type=konsultasi_online&period=${this.state.choice_queue}&page=${this.state.page}&limit=50`,
          { headers }
        );
        await this.setState({
          products: getQueues.data.queues.data,
          data: getQueues.data.queues,
          isLoaded: false,
        });
      } else {
        let getQueues = await axios.get(
          `${API_URL}/admin/queues?filters[payment_status_id]=${this.state.radioValue}type=konsultasi_online&period=${this.state.choice_queue}&page=${this.state.page}&limit=50`,
          { headers }
        );
        await this.setState({
          products: getQueues.data.queues.data,
          data: getQueues.data.queues,
          isLoaded: false,
        });
      }
    };

  handlePrevPage =
    ({ page, onPageChange }) =>
    async () => {
      await this.setState({
        page: this.state.page - 1,
        isLoaded: true,
      });
      if (this.state.radioValue === null) {
        let getQueues = await axios.get(
          `${API_URL}/admin/queues?type=konsultasi_online&period=${this.state.choice_queue}&page=${this.state.page}&limit=50`,
          { headers }
        );
        await this.setState({
          products: getQueues.data.queues.data,
          data: getQueues.data.queues,
          isLoaded: false,
        });
      } else {
        let getQueues = await axios.get(
          `${API_URL}/admin/queues?filters[payment_status_id]=${this.state.radioValue}type=konsultasi_online&period=${this.state.choice_queue}&page=${this.state.page}&limit=50`,
          { headers }
        );
        await this.setState({
          products: getQueues.data.queues.data,
          data: getQueues.data.queues,
          isLoaded: false,
        });
      }
    };

  handleSelectStatus = async (id) => {
    await this.setState({
      radioValue: id,
      isLoaded: true,
    });
    let getQueues = await axios.get(
      `${API_URL}/admin/queues?filters[payment_status_id]=${id}&type=konsultasi_online&period=${this.state.choice_queue}&page=1&limit=50`,
      { headers }
    );
    await this.setState({
      products: getQueues.data.queues.data,
      data: getQueues.data.queues,
      page: 1,
      isLoaded: false,
    });
  };

  render() {
    const customTotal = (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total showing-button">
        Showing {from} to {to} of {size} Results
      </span>
    );
    const options = {
      custom: true,
      totalSize: 10,
      sizePerPage: 100,
    };

    // const isWeekday = date => {
    //   const day = date.getDay()
    //   return day !== 0;
    // };
    // const contentTable = ({ paginationProps, paginationTableProps }) => (
    //   <div className="card shadow mb-4">
    //     <div className="card-body">
    //       <div className="table-responsive">
    //         <ToolkitProvider
    //           keyField="id"
    //           columns={this.state.columns}
    //           data={this.state.products}
    //           search={{ searchFormatted: true }}
    //         >
    //           {(toolkitprops) => (
    //             <div>
    //               <div>
    //               <div className="demo-section float-left" style={{marginBottom:'-5rem'}}>
    //                 <div className="checkbox rounded-8">
    //                   <div className="checkbox-container mt-1">
    //                     <input id="checkbox-rounded-8" type="checkbox" onChange={this.getAllQueue}/>
    //                     <div className="checkbox-checkmark"></div>
    //                   </div>
    //                   <label for="checkbox-rounded-8">
    //                     Tampilkan seluruh antrian (
    //                     <span className="text-danger">
    //                       Pengambilan data akan membutuhkan waktu sedikit lebih lama
    //                     </span>
    //                     )
    //                   </label>
    //                 </div>
    //               </div>
    //               <SearchBar
    //                 {...toolkitprops.searchProps}
    //                 className="search-content float-right"

    //               />
    //               </div><br />

    //               <div style={{paddingTop: '1em'}}>
    //                 <p style={{textAlign: "left"}}>Filter Status Pembayaran: </p>
    //                 <div className="filter-payment-cust">
    //                 {[{id: 1, name: "Belum Bayar"}, {id: 2, name: "Menunggu Konfirmasi"},
    //                   {id: 3, name: "Sudah Bayar"}, {id: 4, name: "Pembayaran Ditolak"},
    //                   {id: 5, name: "Pembayaran Dikembalikan"}, {id: 6, name: "Tampilkan Semua"}].map(num => {
    //                     return (
    //                       <div className="radio-btn-cust">
    //                         <RadioButton
    //                           key={num.id}
    //                           value={num.id}
    //                           text={num.name}
    //                           selected={this.state.radioValue}
    //                           onChange={(e) => {
    //                             this.handleSelectStatus(num.id)
    //                             // this.handleFilter(num.id === 6 ? "" : num.name)
    //                             // this.setState({radioValue: num.id})
    //                             // if(e === 2) {
    //                             //   this.getQueueUpcoming()
    //                             // }
    //                           }}
    //                         />
    //                       </div>

    //                     )
    //                 })}
    //                 </div>

    //               </div>
    //               <BootstrapTable
    //                 bordered={false}
    //                 filter={ filterFactory() }
    //                 {...toolkitprops.baseProps}
    //                 {...paginationTableProps}
    //               />
    //             </div>
    //           )}
    //         </ToolkitProvider>
    //       </div>
    //     </div>
    //   </div>
    // );

    return (
      <div className="admin-overlay">
        <AdminSidebar />
        <LoadingOverlay
          active={this.state.isLoaded}
          spinner
          text="Memuat data..."
        >
          <div className="content-section">
            <div className="title-section">
              <h1 className="patient-page-title">
                Manajemen Antrian Konsultasi Online
              </h1>
              <h2 className="patient-page-subtitle">
                <span style={{ color: '#039BEB' }}>
                  Manajemen Antrian Konsultasi Online
                </span>
                <span style={{ color: '#00000029' }}> / Daftar Tiket</span>
              </h2>
              <div className="add-button float-right mr-3 mb-2">
                <Link to="/add-family">
                  <button className="btn btn-primary mr-1">
                    Buat Data Keluarga
                  </button>
                </Link>
                <Link to="/create-queue-online">
                  <button className="btn btn-primary">Buat Antrian</button>
                </Link>
              </div>
            </div>
            <div className="card shadow mb-4">
              <div className="card-body">
                <div className="table-responsive">
                  <div
                    className="demo-section"
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '3fr 1fr 1fr',
                      gap: '.5em',
                      marginBottom: '1rem',
                    }}
                  >
                    <div className="checkbox rounded-8">
                      <div className="checkbox-container mt-1">
                        <input
                          id="checkbox-rounded-8"
                          type="checkbox"
                          onChange={this.getAllQueue}
                        />
                        <div className="checkbox-checkmark"></div>
                      </div>
                      <label
                        for="checkbox-rounded-8"
                        style={{ lineHeight: '1em' }}
                      >
                        Tampilkan seluruh antrian (
                        <span className="text-danger">
                          Pengambilan data akan membutuhkan waktu sedikit lebih
                          lama
                        </span>
                        )
                      </label>
                    </div>
                    <div>
                      <Button
                        disabled={!this.state.isSearched}
                        onClick={() => this.resetQueue()}
                        variant="danger"
                      >
                        Reset Pencarian
                      </Button>
                    </div>
                    <div>
                      <Button
                        variant="primary"
                        onClick={() => this.setState({ showModal: true })}
                      >
                        Cari Data
                      </Button>
                    </div>
                  </div>
                  <br />
                  <div style={{ paddingTop: '1em' }}>
                    <p style={{ textAlign: 'left' }}>
                      Filter Status Pembayaran:{' '}
                    </p>
                    <div className="filter-payment-cust">
                      {[
                        { id: 1, name: 'Belum Bayar' },
                        { id: 2, name: 'Menunggu Konfirmasi' },
                        { id: 3, name: 'Sudah Bayar' },
                        { id: 4, name: 'Pembayaran Ditolak' },
                      ].map((num) => {
                        return (
                          <div className="radio-btn-cust">
                            <RadioButton
                              key={num.id}
                              value={num.id}
                              text={num.name}
                              selected={this.state.radioValue}
                              onChange={(e) => {
                                this.handleSelectStatus(num.id);
                                // this.handleFilter(num.id === 6 ? "" : num.name)
                                // this.setState({radioValue: num.id})
                                // if(e === 2) {
                                //   this.getQueueUpcoming()
                                // }
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {this.state.isSearched === false ? (
                    <PaginationProvider pagination={paginationFactory(options)}>
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <BootstrapTable
                            keyField="id"
                            bordered={false}
                            data={this.state.products}
                            columns={this.state.columns}
                            {...paginationTableProps}
                          />
                          <div className="float-left ml-5">
                            {this.state.data !== null ? (
                              <p>
                                Data {this.state.data.from} hingga{' '}
                                {this.state.data.to} dari{' '}
                                {this.state.data.total} data
                              </p>
                            ) : (
                              ''
                            )}
                          </div>
                          <div
                            className="btn-group float-right mr-5 text-center"
                            role="group"
                          >
                            <button
                              className="btn btn-info mr-1"
                              disabled={this.state.page === 1}
                              onClick={this.handlePrevPage(paginationProps)}
                            >
                              Prev Page
                            </button>
                            <button
                              className="btn btn-info"
                              disabled={
                                this.state.products.length < 1 ||
                                this.state.data.to === this.state.data.total
                              }
                              onClick={this.handleNextPage(paginationProps)}
                            >
                              Next Page
                            </button>
                          </div>
                        </>
                      )}
                    </PaginationProvider>
                  ) : (
                    <PaginationProvider pagination={paginationFactory(options)}>
                      {({ paginationProps, paginationTableProps }) => (
                        <div>
                          <BootstrapTable
                            keyField="id"
                            bordered={false}
                            data={this.state.products}
                            columns={this.state.columns}
                            {...paginationTableProps}
                          />
                          <div className="float-left ml-5">
                            {this.state.products.length > 0 ? (
                              <p>
                                Hasil Pencarian : {this.state.products.length}{' '}
                                data
                              </p>
                            ) : (
                              ''
                            )}
                          </div>
                          {/* <div
                            className="btn-group float-right mr-5 text-center"
                            role="group" 
                          >
                            <button
                              className="btn btn-info mr-1"
                              disabled={this.state.page === 1}
                              onClick={this.handlePrevPageSearch(
                                paginationProps
                              )}
                            >
                              Prev Page
                            </button>
                            <button
                              className="btn btn-info"
                              onClick={this.handleNextPageSearch(
                                paginationProps
                              )}
                            >
                              Next Page
                            </button>
                          </div> */}
                        </div>
                      )}
                    </PaginationProvider>
                  )}
                </div>
              </div>
            </div>
            <Modal
              style={{ zIndex: 1100 }}
              size="sm"
              show={this.state.showModal}
              onHide={() => this.setState({ showModal: false })}
              // centered
            >
              <Modal.Body>
                <h4 style={{ textAlign: 'center' }}>Pilih Jenis Pencarian</h4>
                <div style={{ padding: '3em 10em' }}>
                  <div style={{ margin: '0 1em' }}>
                    <FormLabel>Periode Antrian</FormLabel>
                    <FormControl
                      as="select"
                      onChange={(e) =>
                        this.setState({ choice_queue: e.target.value })
                      }
                    >
                      <option>---Pilih Periode Antrian---</option>
                      <option value="upcoming">Antrian Mendatang</option>
                      <option value="alltime">Semua Antrian</option>
                    </FormControl>
                  </div>

                  <div style={{ margin: '1em 0 ' }}>
                    {[1, 2].map((item) => (
                      <RadioButton
                        styling={{ border: 'none' }}
                        key={item}
                        value={item}
                        selected={this.state.radioValues}
                        onChange={() => {
                          if (item === 1) {
                            this.setState({
                              date_queue: null,
                            });
                          } else {
                            this.setState({
                              name_patient: '',
                            });
                          }
                          this.setState({ radioValues: item });
                        }}
                        text={
                          item === 1
                            ? 'Cari berdasarkan Nama'
                            : 'Cari berdasarkan Tanggal Antrian'
                        }
                      />
                    ))}
                  </div>

                  <FormControl
                    style={{
                      display: this.state.radioValues === 1 ? '' : 'none',
                    }}
                    type="text"
                    value={this.state.name_patient}
                    onChange={(e) => {
                      this.setState({
                        name_patient: e.target.value,
                        // date_queue: null
                      });
                    }}
                    placeholder="Masukkan nama Pasien"
                  />
                  {this.state.radioValues === 2 && (
                    <DatePicker
                      selected={this.state.date_queue}
                      className="date-picker-custom"
                      onChange={(e) => {
                        // console.log(moment(e).format('YYYY-MM-DD'))
                        this.setState({
                          date_queue: e,
                          // name_patient: ''
                        });
                      }}
                      // excludeDates={excludeDate}
                      // filterDate={isWeekday}
                      locale="id"
                      minDate={new Date()}
                      // locale="id-ID"
                      dateFormat="EEEE, dd MMMM yyyy"
                      placeholderText="Pilih Tanggal"
                      // required
                    />
                  )}

                  <br />
                  <Button
                    variant="primary"
                    block
                    disabled={this.state.radioValues === null}
                    onClick={() => this.searchQueue()}
                  >
                    Cari Data
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </LoadingOverlay>
      </div>
    );
  }
}

export default QueueConsultOnline;
